import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMegaphone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0L0 6v4l2 .75V12a4 4 0 0 0 4 4v-3.75L16 16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMegaphone
